export default "__VITE_PUBLIC_ASSET__548eabe0__"